export const IconsSprite = () => (
  <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
    <defs>
      <symbol id="calendar" viewBox="0 0 10 11">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none">
          <path
            fill="currentColor"
            d="M8.5 1.5H8v-1H7v1H3v-1H2v1h-.5a1 1 0 0 0-1 1v7c0 .6.4 1 1 1h7c.6 0 1-.4 1-1v-7c0-.6-.4-1-1-1Zm0 8h-7V4h7v5.5ZM2.5 5H5v2.5H2.5V5Z"
          />
        </svg>
      </symbol>

      <symbol id="clock" viewBox="0 0 12 12">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none">
          <path fill="currentColor" d="M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1Zm0 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z" />
          <path fill="currentColor" d="M6.3 3.5h-.8v3l2.6 1.6.4-.6L6.2 6V3.5Z" />
        </svg>
      </symbol>

      <symbol id="chevron-down" viewBox="0 0 12 8">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none">
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M10.6.6 6 5.2 1.4.6 0 2l6 6 6-6L10.6.6Z"
            clip-rule="evenodd"
          />
        </svg>
      </symbol>

      <symbol id="comments" viewBox="0 0 28 28">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none">
          <path fill="currentColor" d="M3.3 6H.7v18.7c0 1.4 1.2 2.6 2.6 2.6H22v-2.6H3.3V6Z" />
          <path
            fill="currentColor"
            d="M24.7.7h-16A2.7 2.7 0 0 0 6 3.3v16C6 20.8 7.2 22 8.7 22h16c1.4 0 2.6-1.2 2.6-2.7v-16C27.3 2 26.1.7 24.7.7Zm-8 17.3c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4ZM20 9.8c-.8 1.2-1.6 1.6-2 2.4-.2.3-.3.5-.3 1.6h-2c0-.6-.1-1.5.3-2.2.6-1 1.6-1.6 2.2-2.4.6-1 .3-2.6-1.5-2.6-1.2 0-1.8.9-2 1.6l-1.9-.7a4 4 0 0 1 3.9-2.8c1.6 0 2.7.7 3.3 1.6.5.9.8 2.4 0 3.5Z"
          />
        </svg>
      </symbol>

      <symbol id="drag-n-drop" viewBox="0 0 24 24">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </symbol>

      <symbol id="refresh" viewBox="0 0 24 24">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="1 4 1 10 7 10" />
          <polyline points="23 20 23 14 17 14" />
          <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" />
        </svg>
      </symbol>

      <symbol id="x" viewBox="0 0 24 24">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </symbol>

      <symbol id="external-link" viewBox="0 0 24 24">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
          <polyline points="15 3 21 3 21 9" />
          <line x1="10" y1="14" x2="21" y2="3" />
        </svg>
      </symbol>
    </defs>
  </svg>
);
